module.exports = __webpack_public_path__ + "static/img/nongke.9b2926b8.png";